import { UserPrimitiveParameterValue } from '~/scenes/Automation/Flows/Actions/Base/types.flow';

import { PARAMETER_VALUE_TYPE } from '../constants';

export default (value?: string | null): UserPrimitiveParameterValue => ({
  type: PARAMETER_VALUE_TYPE.USER_PRIMITIVE,
  value,
});
